export interface Player{
    id: string,
    playerId: number,
    name: string,
    status: boolean,
    description: string,
    hasScreenshot: boolean,
    solutionId: string,
    folderId: string,
    lastActiveDate: Date | null,
    config: any,
    screenshotTimestamp: Date | null,
    screenshotTimeZone: string,
    solutionType: string,
    lastScreenshotRequestedDate: Date | null,
    activationDate: Date | null,
    FolderPath: string;
}
export interface PlayerDto{
    id: string,
    name: string,
    description: string,
    solutionId: string
}

export interface PlayerCreateDto {
    playerId: number,
    name: string,
    description: string,
    solutionId: string
}

export interface PlayerLogFilterDto{
    playerId: string,
    startDate: string,
    endDate: string
}

export interface PlayerLog{
    id:string,
    message: string,
    createdOnUtc: Date
}

export interface PlayerActionDto{
    playerId: string,
    actionType: PlayerActionType
}

export interface PlayerMultipleActionDto{
    actionType: PlayerActionType,
    massAction: boolean,
    players: string[]
}

export interface PlayerActivationDto {
    playerId: string;
    status: PlayerActivationStatus;
}
export enum PlayerActionType{
    reboot,
    reRender,
    screenshot,
    teamViewer
}

export enum PlayerActivationStatus{
    activated,
    notFound,
    alreadyActivated
}

export interface PlayerMonitor{
    id: string;
    name: string;
    description: string;
    playerId: boolean;
    timestamp: boolean;
    pcName: boolean;
    ipAddress: boolean;
    solutionName: boolean;
    playerFolderPath: boolean;
    monitorAllPlayers: boolean;
    notificationIntervalHours: number;
    subscribers: Array<MonitorSubscriber>;
    players: Array<MonitorPlayer>;
}

export interface PMSettings {
    description: string;
    playerId: boolean;
    timestamp: boolean;
    pcName: boolean;
    ipAddress: boolean;
    solutionName: boolean;
    playerFolderPath: boolean;
    monitorAllPlayers: boolean;
    notificationIntervalHours: number;
}

export interface MonitorSubscriber {
    id: string;
    name: string;
    email: string;
    type: SubscriberType;
}

export enum SubscriberType {
    User,
    UserGroup
}

export interface MonitorPlayer{
    id: string;
    name: string;
    playerId: number;
}
